"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));
var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));
var _jsxToString = _interopRequireDefault(require("../utils/jsxToString"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _Switch = _interopRequireDefault(require("@mui/material/Switch"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["checked", "label", "labelPlacement", "disabled", "onChange", "helperText", "color", "size"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'Switch';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    switchBase: {},
    checked: {},
    track: {}
    /*dark mode*/
    // darkSwitchBase: {
    //   '& + $track': {
    //     backgroundColor: theme.palette.grey[500],
    //     opacity: 1,
    //   },
    //   '&$checked': {
    //     color: '#4085F3',
    //     '& + $track': {
    //       backgroundColor: '#a7bbd0',
    //       opacity: 1,
    //     },
    //   },
    // },
  };
});
var Switch = function Switch(_ref) {
  var checked = _ref.checked,
    label = _ref.label,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? 'end' : _ref$labelPlacement,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    helperText = _ref.helperText,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var switchClasses = {};
  // dark
  //   ? {
  //       switchBase: classes.darkSwitchBase,
  //       root: classes.root,
  //       track: classes.track,
  //       checked: classes.checked,
  //     }
  //   : {};

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl["default"], {
    variant: "standard",
    children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel["default"], _objectSpread({
      "data-cy": dataCy,
      "data-cy-label": (0, _jsxToString["default"])(label),
      control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch["default"], {
        classes: switchClasses,
        color: color,
        size: size
      }),
      checked: checked,
      label: label,
      labelPlacement: labelPlacement,
      disabled: disabled,
      onChange: onChange
    }, props)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch["default"], _objectSpread({
      "data-cy": dataCy,
      classes: switchClasses,
      checked: checked,
      disabled: disabled,
      onChange: onChange,
      color: color,
      size: size
    }, props)), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], {
      children: helperText
    })]
  });
};
Switch.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired
};
var _default = exports["default"] = Switch;